// Shared file ordering (same rules as the PUC-I / PUC-II / Engg. Physics pages):
// 1) a saved manual `order` wins, 2) otherwise by Unit / Chapter / number in the name,
// 3) then by name, 4) then oldest first.
const ROMAN = { i: 1, v: 5, x: 10, l: 50, c: 100 };
const romanToInt = (r) => {
  let total = 0;
  const str = r.toLowerCase();
  for (let i = 0; i < str.length; i++) {
    const cur = ROMAN[str[i]], next = ROMAN[str[i + 1]] || 0;
    if (!cur) return NaN;
    total += cur < next ? -cur : cur;
  }
  return total;
};
export const extractSeqNumber = (name = "") => {
  const n = String(name).toLowerCase();
  const kw = n.match(/(?:^|[^a-z])(?:unit|chapter|chap|ch|module|mod|lecture|lec|part|week|assignment|assign|set|mt|test)[\s\-_:.#]*([ivx]+|\d+)(?![a-z])/);
  if (kw) {
    const v = /^\d+$/.test(kw[1]) ? parseInt(kw[1], 10) : romanToInt(kw[1]);
    if (!isNaN(v)) return v;
  }
  const nums = n.match(/\d+/g);
  if (nums) return parseInt(nums[nums.length - 1], 10);
  const rm = n.match(/[\s\-_]([ivx]+)\s*$/);
  if (rm) { const v = romanToInt(rm[1]); if (!isNaN(v)) return v; }
  return Infinity;
};
const ts = (c) => (c && typeof c === "object" ? (c.seconds || 0) * 1000 : Number(c) || 0);
export const smartSortFiles = (list) => [...list].sort((a, b) => {
  const ha = typeof a.order === "number", hb = typeof b.order === "number";
  if (ha && hb) return a.order - b.order;
  if (ha) return -1;
  if (hb) return 1;
  const na = extractSeqNumber(a.name), nb = extractSeqNumber(b.name);
  if (na !== nb) return na - nb;
  const byName = (a.name || "").localeCompare(b.name || "", undefined, { numeric: true, sensitivity: "base" });
  return byName || ts(a.createdAt) - ts(b.createdAt);
});
